import React from 'react'

function MessagesSection({
	datesAdjusted,
	pickupWarning,
	deliveryWarning,
	isDarkMode = false,
}) {
	return (
		<>
			{datesAdjusted && (
				<div className={`alert-box alert-info ${isDarkMode ? 'dark' : ''}`}>
					<span className="text-md">🕒</span>
					<div className="text-sm">
						<strong>Notice:</strong> Pickup/delivery times were in the past.
						They’ve been reset to start 2 hours from now — adjust as needed.
					</div>
				</div>
			)}

			{pickupWarning && (
				<div className={`alert-box alert-warning ${isDarkMode ? 'dark' : ''}`}>
					<strong>Warning:</strong> Set your pickup time slightly earlier than
					the load's scheduled pickup to increase order fulfillment chances.
				</div>
			)}

			{deliveryWarning && (
				<div className={`alert-box alert-warning ${isDarkMode ? 'dark' : ''}`}>
					<strong>Warning:</strong> Set your delivery time slightly later than
					the load's scheduled delivery to increase order fulfillment chances.
				</div>
			)}
		</>
	)
}

export default MessagesSection
